(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('PremDiscGroup', PremDiscGroup);

    PremDiscGroup.$inject = ['$resource', 'DateUtils'];

    function PremDiscGroup ($resource, DateUtils) {
        var resourceUrl =  'api/prem-disc-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
